"use client";

import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ReactNode, useContext, useState } from "react";
import { cn } from "@/lib/utils";
import { UserContext } from "@/contexts/user-context";

type ContentType = "description" | "transcription";

export const VideoResourceContent = ({
  patron,
  description,
  transcription,
}: {
  patron: ReactNode;
  description: ReactNode;
  transcription?: ReactNode;
}) => {
  const { isCrawler } = useContext(UserContext) as UserVM;
  const [active, setActive] = useState<ContentType>("description");

  if (!transcription) {
    return (
      <div className={"mt-8"}>
        {patron}
        {description}
      </div>
    );
  }

  if (isCrawler) {
    return (
      <div className={"mt-8"}>
        {patron}
        {description}
        {transcription}
      </div>
    );
  }

  return (
    <div className={"mt-8"}>
      {patron}

      <div
        className={
          "my-6 flex flex-col gap-8 border-b border-zinc-200 pb-6 sm:flex-row sm:items-center sm:justify-between"
        }
      >
        <Nav setActive={setActive} active={active} />
      </div>
      <div className={cn(active !== "description" && "hidden")}>
        {description}
      </div>
      <div className={cn(active !== "transcription" && "hidden")}>
        {transcription}
      </div>
    </div>
  );
};

const Nav = ({
  setActive,
  active,
}: {
  setActive: (type: ContentType) => void;
  active: ContentType;
}) => (
  <Tabs value={active} className={"w-[174px]"}>
    <TabsList className="flex w-full bg-transparent">
      <TabsTrigger
        value={"description"}
        className={cn(
          "w-[55px] px-3 py-1.5 text-sm font-medium shadow-none! hover:cursor-pointer",
          active === "description" && "bg-zinc-100!",
        )}
        onClick={() => {
          setActive("description");
        }}
      >
        Opis
      </TabsTrigger>
      <TabsTrigger
        value={"transcription"}
        className={cn(
          "w-[111px] px-3 py-1.5 text-sm font-medium shadow-none! hover:cursor-pointer",
          active === "transcription" && "bg-zinc-100!",
        )}
        onClick={() => {
          setActive("transcription");
        }}
      >
        Transkrypcja
      </TabsTrigger>
    </TabsList>
  </Tabs>
);
